import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center' as const,
    backgroundColor: white,
  },
  list: {
    backgroundColor: white,
    height: '100%',
  },
});
